import { useCallback } from 'react';

import {
  So5FixtureEvent,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useNextSo5FixtureTeamSlugs } from '@sorare/core/src/hooks/config/useNextSo5FixtureTeamSlugs';

export const useFormatActiveFixtureLabel = () => {
  const { sport } = useSportContext();
  const { formatMessage } = useIntlContext();
  const teamsPlayingNextDailyFixture = useNextSo5FixtureTeamSlugs(
    So5FixtureEvent.DAILY
  );
  const teamsPlayingNextWeeklyFixture = useNextSo5FixtureTeamSlugs(
    So5FixtureEvent.CLASSIC
  );

  const prefix = (() => {
    switch (sport) {
      case Sport.NBA:
        return formatMessage({
          id: 'activeFixtureLabel.daily.baseball',
          defaultMessage: 'Daily Swing',
        });
      case Sport.BASEBALL:
        return formatMessage({
          id: 'activeFixtureLabel.daily.nba',
          defaultMessage: 'Daily Hoops',
        });
      default:
        return '';
    }
  })();

  return useCallback(
    (slug: string | false, type: So5FixtureEvent) => {
      const selectedFixture = (
        type === So5FixtureEvent.DAILY
          ? teamsPlayingNextDailyFixture
          : teamsPlayingNextWeeklyFixture
      ).find(f => f.slug === slug);

      if (selectedFixture) {
        return `${prefix} ${selectedFixture.longDisplayName}`;
      }
      return '';
    },
    [prefix, teamsPlayingNextDailyFixture, teamsPlayingNextWeeklyFixture]
  );
};
